export default [
    {
        // [0]
        key: "type",
        label: "TYPE",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        // [1]
        key: "name",
        label: "NAME",
        visible: true,
    },
    {
        // [2]
        key: "json_users",
        label: "USERS",
        visible: true,
    },
    {
        // [3]
        key: "id",
        label: "actions",
        visible: true,
        tdClass: "text-center"
    },
]